import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="inline-block mb-4 cursor-pointer">
                <span className="text-xl font-bold bg-gradient-to-r from-rose-400 to-orange-400 bg-clip-text text-transparent">
                  51吃瓜
                </span>
              </Link>
              <p className="text-gray-400 text-sm leading-relaxed">
                51吃瓜网站 - 聚焦每日大赛、台北娜娜、莫里秀、玩偶姐姐等热门系列，提供最新合集与高清视频资源，满足深度吃瓜需求。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-gray-300">特色栏目</h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-gray-300">更多栏目</h4>
              <ul className="space-y-2.5">
                {categories.slice(4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-gray-300">关于我们</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/about"
                    className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about#contact"
                    className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    联系我们
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-500 text-xs">
            &copy; {new Date().getFullYear()} 51吃瓜 版权所有 | 本站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-gray-500 hover:text-white text-xs transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-gray-500 hover:text-white text-xs transition-colors cursor-pointer" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}